export default __webpack_public_path__ + "static/storymode-614c42472f262bd612ac0374e6b37177.png";